function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon/building01");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icon/building01",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "house",
  transform: "translate(20.000000, 54.000000)",
  fillRule: "nonzero",
  stroke: "currentColor",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,-3.55271368e-15 L0,32.1726394 L0,46.4046514 C0,51.6820931 4.27751463,56 9.56812483,56 C9.65254946,56 9.70883254,56 9.79325717,56 C9.87768181,56 9.93396489,56 10.0183895,56 L29.8863193,56 C34.839231,56 38.8634717,51.9643093 38.8634717,46.9973053 L38.8634717,23.6966065 C38.8634717,22.9346229 39.4825857,22.3137475 40.2424074,22.3137475 L60.7575926,22.3137475 C61.5174143,22.3137475 62.1365283,22.9346229 62.1365283,23.6966065 L62.1365283,46.9973053 C64.5917334,44.5899221 79.2708333,30.358724 106.173828,4.30371094",
  id: "Shape"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0,73 L33.0796186,40.8359398 M46.2357781,28.0439088 L70.9641031,4 L139,70.6308594",
  id: "Shape",
  stroke: "currentColor",
  strokeWidth: 4
}));

var SvgBuildingOld = function SvgBuildingOld(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 141 124",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBuildingOld, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/building-old.5067b6c8.svg";
export { ForwardRef as ReactComponent };